import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiSongGeneratorConfig } from '@/data/landingConfig/landingAiSongGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiSongGenerator } from './schemaObject';

interface Props {}
const AiSongGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiSongGenerator} />
			<LandingTemplate
				data={landingAiSongGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelMusicGenerator()}
			/>
		</>
	);
};

export default AiSongGenerator;
